import { Component, Inject } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { BaseDialogActionData, ButtonColor, CommonActionKey } from "common";
import { Observable } from "rxjs";
import { CompetitorFormStatusData } from "../../../competitor-form/models/competitor-form-status-data.model";

@Component({
    selector: "ifb-competitors-select-add-dialog",
    templateUrl: "./competitors-select-add-dialog.component.html",
    styleUrls: ["./competitors-select-add-dialog.component.scss"],
    standalone: false
})
export class CompetitorsSelectAddDialogComponent {
  actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.Cancel, label: 'CANCEL', buttonColor: ButtonColor.Default },
    { actionKey: CommonActionKey.Save, label: 'SAVE', buttonColor: ButtonColor.Primary },
  ];

  formData: CompetitorFormStatusData;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CompetitorsSelectAddDialogComponent>
) { }

  static show(dialog: MatDialog): Observable<any> {
    return dialog
      .open(CompetitorsSelectAddDialogComponent, {
        data: {},
        closeOnNavigation: true,
      })
      .afterClosed();
  }

  onFormStatusChanged(data: CompetitorFormStatusData): void {
    this.formData = data;
  }

  onActionClicked(actionData: BaseDialogActionData): void {
    if (actionData.actionKey !== CommonActionKey.Save) {
      return this.dialogRef.close();
    }

    if (!this.formData.isValid) {
      return;
    }

    return this.dialogRef.close(this.formData);
  }
}
